import { render, staticRenderFns } from "./OpinionPublishHome.vue?vue&type=template&id=69d00016&scoped=true&"
import script from "./OpinionPublishHome.vue?vue&type=script&lang=js&"
export * from "./OpinionPublishHome.vue?vue&type=script&lang=js&"
import style0 from "./OpinionPublishHome.vue?vue&type=style&index=0&id=69d00016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d00016",
  null
  
)

export default component.exports